var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"iconBar",style:(_vm.smallPadding)},[_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticStyle:{"margin-left":"20px","cursor":"pointer"},attrs:{"src":require("@/assets/logo/sc_text_logo.png"),"alt":""},on:{"click":function($event){return _vm.$router.push('/')}}})]),_vm._v(" "),_c('top-menu')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f49b04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pageLayout/navbar.vue
// module id = null
// module chunks = 